var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
;
export var CustomCheckbox = function (_a) {
    var name = _a.name, grey = _a.grey, value = _a.value, label = _a.label, checked = _a.checked, onClick = _a.onClick, onChange = _a.onChange, disabled = _a.disabled, className = _a.className, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b;
    var changeHandler = function (e) {
        var generatedTarget = __assign(__assign({}, e), {
            target: {
                type: 'checkbox',
                checked: !checked,
                value: value || null,
                name: name || 'custom-select'
            }
        });
        if (onChange) {
            onChange(generatedTarget, !checked);
        }
    };
    return (React.createElement("div", { className: "custom-checkbox-container " + (fullWidth ? 'full-width-important left' : ''), onClick: function (e) { return onClick ? onClick(e) : null; } },
        React.createElement("div", { onClick: changeHandler, className: "custom-checkbox " + (className || '') + " " + (disabled ? 'disabled' : '') + " " + (grey && !checked ? 'grey' : '') + " " + (checked ? 'show' : 'hide') },
            React.createElement("div", { className: "checked " + (checked ? 'show' : 'hide') })),
        label && (React.createElement("div", { className: "label", onClick: changeHandler }, label))));
};
